/**
* @Author: Dmytro Mykhailov <MSL_Chaos>
* @Date:   2016-10-02T03:15:34+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   MSL_Chaos
* @Last modified time: 2016-10-02T04:51:42+03:00
* @License: MIT
*/



import createReducer from 'utils/redux/createReducer'

const initialState = {
    arrayOfShowable: []
  , hideItem: {}
}

export default createReducer(initialState, {
  /** Using for draw new notification
  * action.data [Object] - new notification object to draw
  * action.data.title [String] - short description of notification
  * action.data.content [String] - Full description of notification
  * action.data.pusher [String] - id of manager who pushed the notification
  * action.data.date [String] - ISO date when notification was created
  * action.data.type [String] - type of notify(for now possible is "task owner change"/"new reply")
  * action.data.link [String] - link for target of notification
  * action.data.read [String] - shows is the manager have seen it
  */
  PUSH_NOTIFICATION: (currentState, action) => ({
      ...currentState
    , arrayOfShowable:
      (currentState.arrayOfShowable.length < 5)?
          [...currentState.arrayOfShowable, action.data]
              : [...currentState.arrayOfShowable.slice(1), action.data]
  }),
  /** Using for draw old notification out
    * action.data [Number] - indx of notification should be removed
  */
  'DISMISS_NOTIFICATION': (currentState, action) => ({
      arrayOfShowable:[...currentState.arrayOfShowable.slice(0, action.data), ...currentState.arrayOfShowable.slice(action.data + 1)]
    , hideItem: currentState.arrayOfShowable[action.data]
  }),
  'CLEAR_DISSMISED': (currentState) => ({
      ...currentState
     , hideItem: {}
  }),
  /** For clear state of showing notifications
  */
  'CLEAR_ALL': () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/notifications.js